











import { Vue, Component, Mixins, Prop } from "vue-property-decorator";
import { instanceOfIDrawableItemEditable } from "./IDrawableItemEditable";
import Empty from "../../system/EmptyComponent.vue";
import {
  DateObjectMenu,
  CircleSelectObjectMenu,
  TextObjectMenu,
  MovableTextObjectMenu,
  ExpressionObjectMenu,
  ComboBoxObjectMenu,
  RollObjectMenu,
  ImageObjectMenu,
  ExternalDataObjectMenu,
  JoinTextObjectMenu,
  RichTextObjectMenu,
  MovableImageObjectMenu,
  ShapeObjectMenu,
} from "./objectMenus";

@Component({
  components: {
    // ここに文書オブジェクトコンポーネントを記載要.DocuCoreとして考えると標準以外の文書オブジェクトをどうサポートするか？要検討.
    // TODO: とりあえず仮実装で未実装の物はNotImplementedで.
    LineItem: ShapeObjectMenu,
    PolylineItem: ShapeObjectMenu,
    TextBoxItem: TextObjectMenu,
    MovableTextBoxItem: MovableTextObjectMenu,
    RichTextBoxItem: RichTextObjectMenu,
    BoxLineItem: ShapeObjectMenu,
    CircleItem: ShapeObjectMenu,
    TriangleItem: ShapeObjectMenu,
    CrossItem: ShapeObjectMenu,
    DateItem: DateObjectMenu,
    CircleSelectItem: CircleSelectObjectMenu,
    CalculateItem: ExpressionObjectMenu,
    ComboBoxItem: ComboBoxObjectMenu,
    ImageItem: ImageObjectMenu,
    CheckBoxItem: Empty,
    NotImplementedItem: Empty,
    RollItem: RollObjectMenu,
    ExternalDataItem: ExternalDataObjectMenu,
    ExternalProcessItem: Empty,
    BarcodeItem: Empty,
    PositionCorrectItem: Empty,
    MovableImageItem: MovableImageObjectMenu,
    NewPageItem: Empty,
    GraphItem: Empty,
    RangeOfMotionItem: Empty,
    HeaderFooterTextItem: Empty,
    JoinTextItem: JoinTextObjectMenu,
    StampItem: Empty,
  }
})
export default class ObjectMenu extends Mixins() {
  @Prop()
  source: Vue;

  @Prop()
  isInputMethodSelectable: boolean;

  @Prop()
  isImageRegistrationEnable: boolean;

  get isVisible(): boolean {
    return !!this.source;
  }

  get key(): string {
    return instanceOfIDrawableItemEditable(this.source)
      ? this.source.editingSource.typeKey
      : "";
  }
}
